export default __webpack_public_path__ + "static/media/clean1.b3098994.png";